<div class="wrapper pt-10 flex flex-col gap-5 items-center">
  <div class="flex flex-col gap-3 max-sm:w-full max-sm:px-5">
    <h2
      class="md:text-header text-brand-primary text-center max-md:text-2xl max-md:font-sans max-md:leading-10 max-md:font-extrabold"
    >
      {{ notFoundPageTexts().PAGE_NOT_FOUND }}
    </h2>
    <p
      class="md:text-sub-header max-md:font-sans max-md:font-bold max-md:text-sm text-neutral-600 text-center"
    >
      {{ notFoundPageTexts().PAGE_NOT_FOUND_MESSAGE }}
      <span
        class="text-brand-secondary underline cursor-pointer"
        [routerLink]="['/']"
        >{{ notFoundPageTexts().PAGE_NOT_FOUND_LINK }}</span
      >
      {{ notFoundPageTexts().PAGE_NOT_FOUND_LINK_ADMIN }}
    </p>
  </div>
  <div class="flex flex-col items-center">
    <h1
      class="text-[164.85px]/[183.2px] font-sans font-extrabold text-neutral-700 max-md:text-8xl"
    >
      404
    </h1>
    <div
      class="container-svg-404 w-[592px] h-[701px] max-[768px]:w-[329px] max-[768px]:h-[409px] max-[386px]:w-full max-[386px]:h-auto max-[386px]:ml-0 md:ml-28 max-md:ml-12 mt-4"
    >
      <img
        src="assets/images/warnings/bg-404.svg"
        alt="404"
        class="h-full w-full"
      />
    </div>
  </div>
</div>
